module.exports = __webpack_public_path__ + "img/gallery-birthday-cover.7e21decf.png";